const item_de = {
  title: 'Artikel',
  allItems: 'Alle Artikel',
  sets: 'Sets',
  table: {
    no: 'Nr.',
    name: 'Name',
    minimumStock: 'Mindestbestand',
    physicalStock: 'Bestandsmenge',
    groupCode: 'Gruppencode',
    group: 'Gruppe',
    tag: 'Tag',
    lastChange: 'Letzte Änderung',
    assignTag: 'Tag zuweisen',
  },
  form: {
    title: 'Tag zuweisen',
    tag: 'Tag',
    tagPlaceholder: 'Tag auswählen',
    tagRequired: 'Tag ist erforderlich',
    cancel: 'Abbrechen',
    assign: 'Zuweisen',
  },
  detail: {
    title: 'Artikeldetails',
    back: 'Zurück',
    name: 'Name',
    no: 'Nr.',
    measurementUnitID: 'Maßeinheit',
    powerConsumption: 'Stromverbrauch (KWH)',
    groupCode: 'Gruppencode',
    minimumStock: 'Mindestbestand',
    packagingFactor: 'Verpackungsfaktor',
    unitsPerBox: 'Einheiten pro Box',
    unitsPerPallet: 'Einheiten pro Palette',
    weight: 'Gewicht',
    width: 'Breite (in mm)',
    depth: 'Tiefe (in mm)',
    height: 'Höhe (in mm)',
  },
  individual: {
    title: 'Einzelkomponenten',
  },
  customTexts: {
    name: 'Ihre Bezeichnung',
    description: 'Ihre Beschreibung',
    addTitle: 'Bezeichnung hinzufügen',
    editTitle: 'Bezeichnung bearbeiten',
    namePlaceholder: 'Bezeichnung eingeben',
    descriptionPlaceholder: 'Beschreibung eingeben',
    save: 'Speichern',
    remove: 'Entfernen',
    saveSuccess: 'Bezeichnung gespeichert',
    removeSuccess: 'Bezeichnung entfernt',
    nameRequired: 'Bitte geben Sie eine Bezeichnung ein',
  },
  message: {
    assignSuccess: 'Tag wurde erfolgreich zugewiesen',
    assignFailed: 'Zuweisen des Tags ist fehlgeschlagen',
  },
  share: {
    action: 'Teilen',
    articleTitle: 'Artikel teilen',
    groupTitle: 'Gruppe teilen',
    wholeOrganization: 'Mit der gesamten Organisation',
    specificCustomers: 'Mit bestimmten Kunden',
    addCustomer: '+ Kunde hinzufügen',
    selectCustomer: 'Kunde auswählen',
    you: 'Sie',
    noCustomers: 'Keine weiteren Kunden in Ihrer Organisation',
    customersRequired: 'Mindestens einen Kunden hinzufügen',
    cancel: 'Abbrechen',
    submit: 'Teilen',
    revoke: 'Freigabe aufheben',
    badge: 'geteilt',
    badgeCount: 'geteilt mit {count} Kunden | geteilt mit {count} Kunden',
    inherited: 'über Gruppe geteilt',
    sharedBy: 'geteilt von {customer}',
    shareSuccess: 'Freigabe gespeichert',
    revokeSuccess: 'Freigabe aufgehoben',
  },
  filter: {
    title: 'Filter',
    group: 'Gruppe',
    groupPlaceholder: 'Gruppe auswählen',
    subGroup: 'Untergruppe',
    subGroupPlaceholder: 'Untergruppe auswählen',
    tag: 'Tag',
    tagPlaceholder: 'Tag auswählen',
    category: 'Kategorie',
    categoryPlaceholder: 'Kategorie',
    // {0} ist die Anzahl der Auswahl, von PrimeVues MultiSelect eingesetzt.
    categoriesSelected: '{0} Kategorien',
    cancel: 'Abbrechen',
    apply: 'Anwenden',
  },
}

export default item_de
